import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/components/Home.vue";

Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      components: {
        default: Home
      }
    },
    {
      path: "/books",
      name: "BookList",
      components: {
        default: () =>
          import(/* webpackChunkName: "books" */ "../components/BookList.vue")
      }
    },
    {
      path: "/books/:repoId",
      name: "Book",
      components: {
        default: () =>
          import(/* webpackChunkName: "book" */ "../components/BookPage.vue")
      }
    },
    {
      path: "/repos/:repoId",
      name: "Repo",
      components: {
        default: () =>
          import(/* webpackChunkName: "repo" */ "../components/RepoPage.vue")
      }
    },
    {
      path: "/repos/:repoId/docs/:docId",
      name: "Doc",
      components: {
        default: () =>
          import(/* webpackChunkName: "repo" */ "../components/RepoPage.vue")
      }
    }
  ]
});
